export const state = () => ({
  activationPresented: false,
  activationTimerTimestamp: '',
  timerShowedupInCart: false,
  activationTimestamp: null,
  activationToPresent: null,
  sessionToken: null,
  currentUser: null,
  shortLink: null,
  componentDataCollection: {},
  pricesFilter: [],
  listCache: {},
  categoryTree: { name: 'All', subEntries: [{ name: 'Recommended', id: '25', subEntries: [{ name: "Men's", id: '21' }, { name: "Women's", id: '68' }] }, { name: "Men's", id: '21', subEntries: [{ name: 'Clothing', id: '53', subEntries: [{ name: 'Shirts', id: '95' }, { name: 'Jackets & Coats', id: '13' }, { name: 'Sweaters', id: '45' }, { name: 'T-Shirt', id: '40', subEntries: [{ name: 'Polo shirts', id: '15' }, { name: 'Long Sleeve', id: '91' }, { name: 'Tanks', id: '67' }, { name: 'Short Sleeve', id: '24' }] }, { name: 'Sweatshirts', id: '69' }, { name: 'Underwear', id: '5' }, { name: 'Shorts', id: '89' }, { name: 'Pants', id: '43', subEntries: [{ name: 'Joggers', id: '7' }, { name: 'Chinos', id: '34' }, { name: 'Jeans', id: '29' }] }] }, { name: 'Accessories', id: '39', subEntries: [{ name: 'Wallets', id: '96' }, { name: 'Watches', id: '64' }, { name: 'Glasses', id: '26' }, { name: 'Beauty & Perfumes', id: '48' }, { name: 'Bags', id: '44' }, { name: 'Jewlery', id: '85' }, { name: 'Caps', id: '80' }, { name: 'Others', id: '42' }] }, { name: 'Shoes', id: '38', subEntries: [{ name: 'Sports', id: '90' }, { name: 'Sandals', id: '37' }, { name: 'Boots', id: '70' }, { name: 'Sneakers', id: '93' }, { name: 'Dress', id: '58' }] }] }, { name: "Women's", id: '68', subEntries: [{ name: 'Beauty', id: '49', subEntries: [{ name: 'Make Up', id: '57' }, { name: 'Fragrance', id: '23' }, { name: 'Others', id: '42' }, { name: 'Skin Care', id: '30' }] }, { name: 'Accessories', id: '39', subEntries: [{ name: 'Others', id: '42' }, { name: 'Bags', id: '44' }, { name: 'Hats', id: '65' }, { name: 'Watches', id: '64' }, { name: 'Belts', id: '73' }, { name: 'Jewlery', id: '85', subEntries: [{ name: 'Earrings', id: '88' }, { name: 'Rings', id: '60' }, { name: 'Necklace', id: '36' }, { name: 'Bracelet', id: '86' }] }, { name: 'Sunglasses', id: '16' }, { name: 'Hair', id: '66' }] }, { name: 'Clothing', id: '53', subEntries: [{ name: 'Bras, Panties & Shapewear', id: '32' }, { name: 'Tops', id: '31', subEntries: [{ name: 'Long Sleeve', id: '91' }, { name: 'Short', id: '2' }, { name: 'Dress Shirts', id: '35' }, { name: 'Tanks', id: '67' }] }, { name: 'Sweats and Hoodie', id: '76' }, { name: 'Skirts', id: '8' }, { name: 'Swimwear', id: '6' }, { name: 'Jumpsuits & Rompers', id: '72' }, { name: 'Jackets & Coats', id: '18' }, { name: 'Dresses', id: '84' }, { name: 'Bottoms', id: '79', subEntries: [{ name: 'Jeans', id: '29' }, { name: 'Shorts', id: '89' }, { name: 'Joggers', id: '7' }, { name: 'Pants', id: '43' }] }] }, { name: 'Shoes', id: '38', subEntries: [{ name: 'Sneakers', id: '93' }, { name: 'High Heels', id: '83' }, { name: 'Boots', id: '70' }, { name: 'Sports', id: '90' }, { name: 'Flats', id: '97' }] }] }, { name: 'Gadgets', id: '19', subEntries: [{ name: 'Laptop Accessories', id: '50' }, { name: 'Other', id: '33' }, { name: 'Camera', id: '78' }, { name: 'Phone Accessories', id: '17' }, { name: 'Kitchen ', id: '20' }, { name: 'Audio', id: '63' }] }, { name: 'Home', id: '10' }, { name: 'Plus Size (New)', id: '100', subEntries: [{ name: "Men's", id: '21', subEntries: [{ name: 'Clothing', id: '53', subEntries: [{ name: 'T-Shirt', id: '40', subEntries: [{ name: 'Short Sleeve', id: '24' }, { name: 'Long Sleeve', id: '91' }, { name: 'Tanks', id: '67' }, { name: 'Polo shirts', id: '15' }] }, { name: 'Pants', id: '43', subEntries: [{ name: 'Chinos', id: '34' }, { name: 'Jeans', id: '29' }, { name: 'Joggers', id: '7' }] }, { name: 'Shirts', id: '95' }, { name: 'Shorts', id: '89' }, { name: 'Sweatshirts', id: '69' }, { name: 'Sweaters', id: '45' }, { name: 'Jackets & Coats', id: '13' }, { name: 'Underwear', id: '5' }] }, { name: 'Shoes', id: '38', subEntries: [{ name: 'Sneakers', id: '93' }, { name: 'Dress', id: '58' }, { name: 'Boots', id: '70' }, { name: 'Sports', id: '90' }, { name: 'Sandals', id: '37' }] }, { name: 'Accessories', id: '39', subEntries: [{ name: 'Glasses', id: '26' }, { name: 'Beauty & Perfumes', id: '48' }, { name: 'Jewlery', id: '85' }, { name: 'Bags', id: '44' }, { name: 'Watches', id: '64' }, { name: 'Wallets', id: '96' }, { name: 'Caps', id: '80' }, { name: 'Others', id: '42' }] }] }, { name: "Women's", id: '74', subEntries: [{ name: 'Clothing', id: '53', subEntries: [{ name: 'T-Shirt', id: '40', subEntries: [{ name: 'Short Sleeve', id: '24' }, { name: 'Long Sleeve', id: '91' }, { name: 'Tanks', id: '67' }, { name: 'Polo shirts', id: '15' }] }, { name: 'Pants', id: '43', subEntries: [{ name: 'Chinos', id: '34' }, { name: 'Jeans', id: '29' }, { name: 'Joggers', id: '7' }] }, { name: 'Shirts', id: '95' }, { name: 'Shorts', id: '89' }, { name: 'Sweatshirts', id: '69' }, { name: 'Jackets & Coats', id: '18' }, { name: 'Underwear', id: '5' }] }] }] }, { name: 'Kids', id: '59', subEntries: [{ name: 'Boys', id: '28', subEntries: [{ name: 'Tops', id: '31' }] }] }, { name: 'Subscriptions', id: '101' }, { name: 'Matching Sets', id: '102', subEntries: [{ name: 'Shirt & Pants Sets', id: '103' }, { name: 'Tracksuits', id: '104' }, { name: 'Shorts Sets', id: '105' }] }] },
  feedType: null,
  genderFilter: null,
  homeFilter: null,
  categoryMap: { 2: 'Short', 5: 'Underwear', 6: 'Swimwear', 7: 'Joggers', 8: 'Skirts', 10: 'Home', 13: 'Jackets & Coats', 15: 'Polo shirts', 16: 'Sunglasses', 17: 'Phone Accessories', 18: 'Jackets & Coats', 19: 'Gadgets', 20: 'Kitchen ', 21: "Men's", 23: 'Fragrance', 24: 'Short Sleeve', 25: 'Recommended', 26: 'Glasses', 28: 'Boys', 29: 'Jeans', 30: 'Skin Care', 31: 'Tops', 32: 'Bras, Panties & Shapewear', 33: 'Other', 34: 'Chinos', 35: 'Dress Shirts', 36: 'Necklace', 37: 'Sandals', 38: 'Shoes', 39: 'Accessories', 40: 'T-Shirt', 42: 'Others', 43: 'Pants', 44: 'Bags', 45: 'Sweaters', 48: 'Beauty & Perfumes', 49: 'Beauty', 50: 'Laptop Accessories', 53: 'Clothing', 57: 'Make Up', 58: 'Dress', 59: 'Kids', 60: 'Rings', 63: 'Audio', 64: 'Watches', 65: 'Hats', 66: 'Hair', 67: 'Tanks', 68: "Women's", 69: 'Sweatshirts', 70: 'Boots', 72: 'Jumpsuits & Rompers', 73: 'Belts', 74: "Women's", 76: 'Sweats and Hoodie', 78: 'Camera', 79: 'Bottoms', 80: 'Caps', 83: 'High Heels', 84: 'Dresses', 85: 'Jewlery', 86: 'Bracelet', 88: 'Earrings', 89: 'Shorts', 90: 'Sports', 91: 'Long Sleeve', 93: 'Sneakers', 95: 'Shirts', 96: 'Wallets', 97: 'Flats', 100: 'Plus Size (New)', 101: 'Subscriptions', 102: 'Matching Sets', 103: 'Shirt & Pants Sets', 104: 'Tracksuits', 105: 'Shorts Sets' },
  pushToken: null,
  firstVisit: null,
  lastActivationPresented: null,
  numOfActivationPresentedToday: 0,
  mostWantedGender: 'Men\'s',
  featuredItemIndex: 0,
  categoryTreeVersion: '-1',
  cache: {}
})

export const mutations = {
  setSessionToken (state, token) {
    state.sessionToken = token
  },
  setActivationPresented (state, presented) {
    state.activationPresented = presented
  },
  setActivationTimestamp (state, data) {
    state.activationTimestamp = data
  },
  setActivationTimerTimestamp (state, data) {
    state.activationTimerTimestamp = data
  },
  setTimerShowedupInCart (state, showedUp) {
    state.timerShowedupInCart = showedUp
  },
  setActivationToPresent (state, activation) {
    state.activationToPresent = activation
  },
  setHomeFilter (state, homeFilter) {
    state.homeFilter = homeFilter
  },
  setGenderFilter (state, genderFilter) {
    state.genderFilter = genderFilter
  },
  setCurrentUser (state, user) {
    state.currentUser = user
  },
  setShortLink (state, shortLink) {
    state.shortLink = shortLink
  },
  setBirthDate (state, birthDate) {
    state.currentUser.birthday = new Date(birthDate).getTime()
  },
  increaseFollowing (state) {
    state.currentUser.followingCount++
  },
  setFeaturedIndex (state, index) {
    state.featuredItemIndex = index
  },
  setCategoryTree (state, categoryTree) {
    state.categoryTree = categoryTree
  },
  setCategoryMap (state, categoryMap) {
    state.categoryMap = categoryMap
  },
  setPricesFilter (state, pricesFilter) {
    state.pricesFilter = pricesFilter
  },
  decreaseFollowing (state) {
    state.currentUser.followingCount--
  },
  updateUser (state, update) {
    Object.keys(update).forEach((key) => {
      state.currentUser[key] = update[key]
    })
  },
  updatePushToken (state, { pushToken }) {
    state.pushToken = pushToken
  },
  setFirstVisitDate (state, { firstVisit }) {
    if (state.firstVisit == null) {
      state.firstVisit = firstVisit
    }
  },
  setLastActivationPresented (state, { lastActivationPresented }) {
    if (state.lastActivationPresented == null) {
      state.lastActivationPresented = lastActivationPresented
    }
  },
  resetLastActivationPresented (state, { lastActivationPresented }) {
    state.lastActivationPresented = lastActivationPresented
  },
  increaseNumOfActivationPresentedToday (state) {
    if (state.numOfActivationPresentedToday === undefined) {
      state.numOfActivationPresentedToday = 1
    } else {
      state.numOfActivationPresentedToday += 1
    }
  },
  resetNumOfActivationPresentedToday (state) {
    state.numOfActivationPresentedToday = 0
  },
  updateMostWantedGender (state, { gender }) {
    state.mostWantedGender = gender
  },
  setCategoryTreeVersion (state, { version }) {
    state.categoryTreeVersion = version
  },
  storeListResults (state, data) {
    state.listCache[data.key] = JSON.stringify(data.data)
  },
  storeComponentData (state, { screen, componentData }) {
    if (state.componentDataCollection[screen]) {
      state.componentDataCollection[screen] = componentData
    }
  },
  saveFeedType (state, { type }) {
    state.feedType = type
  },
  clear (state) {
    state.sessionToken = null
    state.currentUser = null
    state.componentDataCollection = {}
    state.listCache = {}
  }
}

export const getters = {
  getSessionToken: (state) => {
    return state.sessionToken
  },
  getFeedType: state => () => {
    return state.feedType || 'grid'
  }
}
